import { render } from "./VoceNode.vue?vue&type=template&id=09c91775&scoped=true"
import script from "./VoceNode.vue?vue&type=script&lang=js"
export * from "./VoceNode.vue?vue&type=script&lang=js"

import "./VoceNode.vue?vue&type=style&index=0&id=09c91775&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c91775"]])

export default __exports__